export default "__VITE_ASSET__da708d8d__"